import { ProfileSkills } from '@seek/profile-read-ui';
import { useTranslations } from '@vocab/react';
import {
  Actions,
  Button,
  Heading,
  Stack,
  Text,
  Box,
  Alert,
  Strong,
} from 'braid-design-system';

import type { Skill } from 'src/__generated__/graphql';
import { useEditorDrawer } from 'src/ui/EditorDrawer/EditorDrawer';

import translations from './.vocab';

interface Props {
  skills: Skill[];
}

export function SkillsList({ skills }: Props) {
  const { t } = useTranslations(translations);
  const { onEditorOpen } = useEditorDrawer();

  return (
    <Stack space="large">
      <Heading level="3">{t('Skills')}</Heading>
      {skills.length === 0 && (
        <Text tone="secondary">{t('Let employers know')}</Text>
      )}
      <Box data-testid="skills-items">
        <ProfileSkills skills={skills.map((skill) => skill.keyword.text)} />
      </Box>
      {skills.length < 5 && (
        <Alert tone="info" data={{ testid: 'alert-text' }}>
          <Text>
            {t('Adding 5 or more skills', {
              Bold: (v) => <Strong key={`skill-${v}`}>{v}</Strong>,
            })}
          </Text>
        </Alert>
      )}
      <Actions>
        <Button
          tone="formAccent"
          variant="ghost"
          onClick={() => onEditorOpen()}
          data={{ testid: 'add-skills' }}
        >
          {t('Add skills')}
        </Button>
      </Actions>
    </Stack>
  );
}
